shadow$provide[530] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, API:{enumerable:true, get:function() {
  return API;
}}});
var Pretty = require("../util/pretty.js");
var ShaderGraph = require("shadergraph");
class API {
  v2() {
    return this;
  }
  constructor(_context, _up, _targets) {
    this._context = _context;
    this._up = _up;
    this._targets = _targets;
    const root = this._context.controller.getRoot();
    if (this._targets == null) {
      this._targets = [root];
    }
    this.isRoot = this._targets.length === 1 && this._targets[0] === root;
    this.isLeaf = this._targets.length === 1 && this._targets[0].children == null;
    for (let i = 0; i < this._targets.length; i++) {
      const t = this._targets[i];
      this[i] = t;
    }
    this.length = this._targets.length;
    for (const type of Array.from(this._context.controller.getTypes())) {
      if (!["root"].includes(type)) {
        this[type] = (options, binds) => this.add(type, options, binds);
      }
    }
  }
  select(selector) {
    const targets = this._context.model.select(selector, !this.isRoot ? this._targets : null);
    return this._push(targets);
  }
  eq(index) {
    if (this._targets.length > index) {
      return this._push([this._targets[index]]);
    }
    return this._push([]);
  }
  filter(callback) {
    if (typeof callback === "string") {
      const matcher = this._context.model._matcher(callback);
      callback = x => matcher(x);
    }
    return this._push(this._targets.filter(callback));
  }
  map(callback) {
    return __range__(0, this.length, false).map(i => callback(this[i], i, this));
  }
  each(callback) {
    for (let i = 0, end = this.length, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
      callback(this[i], i, this);
    }
    return this;
  }
  add(type, options, binds) {
    const {controller} = this._context;
    if (this.isLeaf) {
      return this._pop().add(type, options, binds);
    }
    const nodes = [];
    for (const target of this._targets) {
      const node = controller.make(type, options, binds);
      controller.add(node, target);
      nodes.push(node);
    }
    return this._push(nodes);
  }
  remove(selector) {
    if (selector) {
      return this.select(selector).remove();
    }
    for (const target of Array.from(this._targets.slice().reverse())) {
      this._context.controller.remove(target);
    }
    return this._pop();
  }
  set(key, value) {
    for (const target of Array.from(this._targets)) {
      this._context.controller.set(target, key, value);
    }
    return this;
  }
  getAll(key) {
    return Array.from(this._targets).map(target => this._context.controller.get(target, key));
  }
  get(key) {
    return this._targets[0] != null ? this._targets[0].get(key) : undefined;
  }
  evaluate(key, time) {
    return this._targets[0] != null ? this._targets[0].evaluate(key, time) : undefined;
  }
  bind(key, value) {
    for (const target of Array.from(this._targets)) {
      this._context.controller.bind(target, key, value);
    }
    return this;
  }
  unbind(key) {
    for (const target of Array.from(this._targets)) {
      this._context.controller.unbind(target, key);
    }
    return this;
  }
  end() {
    return (this.isLeaf ? this._pop() : this)._pop();
  }
  _push(targets) {
    return new API(this._context, this, targets);
  }
  _pop() {
    return this._up != null ? this._up : this;
  }
  _reset() {
    let left;
    return (left = this._up != null ? this._up.reset() : undefined) != null ? left : this;
  }
  map(callback) {
    return this._targets.map(callback);
  }
  on() {
    const args = arguments;
    this._targets.map(x => x.on.apply(x, args));
    return this;
  }
  off() {
    const args = arguments;
    this._targets.map(x => x.off.apply(x, args));
    return this;
  }
  toString() {
    const tags = this._targets.map(x => x.toString());
    if (this._targets.length > 1) {
      return `[${tags.join(", ")}]`;
    } else {
      return tags[0];
    }
  }
  toMarkup() {
    const tags = this._targets.map(x => x.toMarkup());
    return tags.join("\n\n");
  }
  print() {
    Pretty.print(this._targets.map(x => x.toMarkup()).join("\n\n"));
    return this;
  }
  debug() {
    const info = this.inspect();
    console.log("Renderables: ", info.renderables);
    console.log("Renders: ", info.renders);
    console.log("Shaders: ", info.shaders);
    const getName = owner => owner.constructor.name;
    const shaders = [];
    for (const shader of Array.from(info.shaders)) {
      const name = getName(shader.owner);
      shaders.push(`${name} - Vertex`);
      shaders.push(shader.vertex);
      shaders.push(`${name} - Fragment`);
      shaders.push(shader.fragment);
    }
    return ShaderGraph.inspect(shaders);
  }
  inspect(selector, trait, print) {
    let self;
    if (typeof trait === "boolean") {
      print = trait;
      trait = null;
    }
    if (print == null) {
      print = true;
    }
    const map = node => (node.controller != null ? node.controller.objects : undefined) != null ? node.controller != null ? node.controller.objects : undefined : [];
    const recurse = self = function(node, list) {
      if (list == null) {
        list = [];
      }
      if (!trait || node.traits.hash[trait]) {
        list.push(map(node));
      }
      if (node.children != null) {
        for (const child of Array.from(node.children)) {
          self(child, list);
        }
      }
      return list;
    };
    const flatten = function(list) {
      list = list.reduce((a, b) => a.concat(b), []);
      return list = list.filter((x, i) => x != null && list.indexOf(x) === i);
    };
    const make = function(renderable, render) {
      const d = {};
      d.owner = renderable;
      d.geometry = render.geometry;
      d.material = render.material;
      d.vertex = render.userData.vertexGraph;
      d.fragment = render.userData.fragmentGraph;
      return d;
    };
    const info = {nodes:this._targets.slice(), renderables:[], renders:[], shaders:[],};
    for (const target of Array.from(this._targets)) {
      let renderables;
      if (print) {
        target.print(selector, "info");
      }
      const _info = {renderables:renderables = flatten(recurse(target)), renders:flatten(renderables.map(x => x.renders)), shaders:flatten(renderables.map(x => x.renders != null ? x.renders.map(r => make(x, r)) : undefined)),};
      for (const k in _info) {
        info[k] = info[k].concat(_info[k]);
      }
    }
    return info;
  }
}
function __range__(left, right, inclusive) {
  const range = [];
  const ascending = left < right;
  const end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}

};